import React from 'react';
import { Coins } from 'lucide-react';
import { SlotMachine } from './components/game/SlotMachine/SlotMachine';
import { BonusPanel } from './components/game/BonusPanel/BonusPanel';
import CoinWidget from './components/CoinWidget';
import Modal from './components/Modal';
import { useSlotGame } from './features/slots/hooks/useSlotGame';

function App() {
  const {
    balance,
    slots,
    isSpinning,
    activeBonus,
    spin,
    activateBonus,
    setBalance
  } = useSlotGame();

  const [isModalOpen, setIsModalOpen] = React.useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-b from-purple-900 to-purple-700 flex items-center justify-center">
      <div className="bg-white/10 backdrop-blur-lg p-8 rounded-2xl shadow-2xl text-white max-w-md w-full">
        <div className="flex items-center justify-between mb-8">
          <h1 className="text-2xl font-bold">WagerCraft Slot Demo</h1>
          <div className="flex items-center gap-2">
            <Coins className="text-yellow-400" />
            <span className="font-mono text-xl">
              {balance.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}
            </span>
          </div>
        </div>

        {activeBonus && <BonusPanel bonus={activeBonus} />}

        <SlotMachine
          slots={slots}
          isSpinning={isSpinning}
          onSpin={spin}
          disabled={isSpinning || balance < 10}
        />
      </div>

      <div className="fixed bottom-8 right-8">
        <CoinWidget onClick={() => setIsModalOpen(true)} />
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onActivateBonus={activateBonus}
        balance={balance}
        setBalance={setBalance}
        activeBonus={activeBonus}
      />
    </div>
  );
}

export default App;